import { render } from "./BoardList.vue?vue&type=template&id=03894de6&scoped=true"
import script from "./BoardList.vue?vue&type=script&lang=js"
export * from "./BoardList.vue?vue&type=script&lang=js"

import "./BoardList.vue?vue&type=style&index=0&id=03894de6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03894de6"],['__file',"src/views/userSupport/board/BoardList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03894de6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03894de6', __exports__)) {
    api.reload('03894de6', __exports__)
  }
  
  module.hot.accept("./BoardList.vue?vue&type=template&id=03894de6&scoped=true", () => {
    api.rerender('03894de6', render)
  })

}


export default __exports__